/**
 * Страница приложения в магазине — туда ведут «Обновить» на жёстком экране «Нужно обновить приложение»
 * (`components/UpdateRequiredScreen.tsx`) и на мягкой плашке «Вышла новая версия» (`components/UpdateBanner.tsx`).
 * До 15.10.2026 адреса жили в самом экране; вынесены, чтобы у двух кнопок был один адрес.
 *
 * ⚠️ До 15.09.2026 здесь стояла заглушка `id0000000000`, и на Android кнопка тоже вела в App Store:
 * человек, которого не пускает старая версия, попадал на несуществующую страницу. Номер iOS —
 * из кабинета App Store Connect (TASKS п. 106). Платформа — так же, как в `lib/updateGate.ts`.
 *
 * ⚠️ ANDROID — `applicationId` из `android/app/build.gradle`, А НЕ `appId` из capacitor.config.ts.
 * До 16.09.2026 здесь стоял `kz.onebilim.app`: это идентификатор iOS, в Google Play опубликовано
 * `kz.onebilim.academy`, и кнопка вела на «Приложение не найдено» (техдолг п. 234). Сверяет
 * `lib/androidStore.test.ts`.
 *
 * ⚠️ Адрес https, а не `market://`. Нажатие на ссылку Capacitor отдаёт системе, и если открыть её
 * нечем, ошибка глотается молча — запасной путь из страницы не сработает. https-адрес приложение
 * Play перехватывает само, а на телефоне без Play он откроется в браузере.
 *
 * ⚠️ ОТКРЫВАТЬ ОБЫЧНОЙ ССЫЛКОЙ `<a href>`, НЕ `openExternal`. Ссылку Capacitor отдаёт системе, и App Store / Play
 * перехватывают её сами; через окно браузера (`Browser.open`) ученик увидел бы веб-страницу магазина.
 *
 * ⚠️ iOS — карточка 1 BILIM ACADEMY (`kz.onebilim.academy`, app 6756540488) с 61 (D74, 26.09.2026). Прежний
 * номер 6803862898 — карточка `kz.onebilim.app`, куда 61 больше не идёт.
 */
export const STORE_URL = {
  ios: 'https://apps.apple.com/app/id6756540488',
  android: 'https://play.google.com/store/apps/details?id=kz.onebilim.academy',
} as const;
